import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WebResponse } from '@commons/models/remote.response/WebResponse';

import { map, Observable, of } from 'rxjs';

import { BaseHttpService } from '@shared/services-http/base-http.service';
import { IOrganizationUnit, IOrganizationVehicleUnit } from '@src/app/interfaces/api/organization-units.interface';
import { FilterDuplicateOrganization } from '@src/app/utils/organizations/filter-organization-duplicate';

@Injectable({
  providedIn: 'root'
})
export class UserOrganizationsUnitsService extends BaseHttpService {

  private readonly filterDuplicateOrganization = new FilterDuplicateOrganization();

  private organizationalUnitsCache: IOrganizationVehicleUnit[];

  constructor(
    private httpClient: HttpClient,
  ) {
    super();
  }

  public GetOwnersForCurrentUser(): Observable<IOrganizationUnit[]> {
    return this.httpClient.get<WebResponse>(this.getUrl('/GetOwnersForCurrentUser'))
    .pipe(
      map(res => this.filterDuplicateOrganization.filter(res.Result.Owners.filter((el: IOrganizationUnit) => el))),
    );
  }

  public GetOrganizationalUnits(): Observable<IOrganizationVehicleUnit[]> {
    if (this.organizationalUnitsCache?.length) {
      return of(this.organizationalUnitsCache);
    }
    return this.httpClient.get<WebResponse>(this.getUrl('/GetOrganizationalUnits'))
    .pipe(
      map(res => res.Result.Units),
    );
  }

}
